import { render } from "./TemplateHtmlPreviewSlider.vue?vue&type=template&id=65494d16&scoped=true"
import script from "./TemplateHtmlPreviewSlider.vue?vue&type=script&lang=ts"
export * from "./TemplateHtmlPreviewSlider.vue?vue&type=script&lang=ts"

import "./TemplateHtmlPreviewSlider.vue?vue&type=style&index=0&id=65494d16&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-65494d16"

export default script